<!-- 自动出价配置 -->
<template>
    <router-view v-if="$route.path !== '/autopricesetting'"></router-view>
    <div class="practical-table" v-else ref="scrollableDiv">
        <div class="container card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- 品牌映射 -->
                <el-tab-pane label="品牌映射" name="brandcheck">
                    <brandcheckView></brandcheckView>
                </el-tab-pane>

                <!-- 型号映射 -->
                <el-tab-pane label="型号映射" name="modelcheck">
                    <modelcheckView ref="modelcheckRef"></modelcheckView>
                </el-tab-pane>

                <!-- 瑕疵映射 -->
                <el-tab-pane label="瑕疵映射" name="pjtdamagecheck">
                    <damagecheckView ref="pjtdamagecheckRef"></damagecheckView>
                </el-tab-pane>

                <!-- 成色判定 -->
                <el-tab-pane label="成色判定" name="conditioncheck">
                    <conditioncheckView ref="conditioncheckRef"></conditioncheckView>
                </el-tab-pane>

                <!-- 公式配置 -->
                <el-tab-pane label="公式配置" name="second">
                    <calfuncheckView ref="calfuncheckRef"></calfuncheckView>
                </el-tab-pane>

                <!-- 筛选词配置 -->
                <el-tab-pane label="筛选词配置" name="filterwordcheck">
                    <filterwordcheckView ref="filterwordcheckViewRef"></filterwordcheckView>
                </el-tab-pane>

                <!-- 红包配置 -->
                <el-tab-pane label="红包配置" name="redpack">
                    <redpacketView></redpacketView>
                </el-tab-pane>

                <!-- 准入配置 -->
                <el-tab-pane label="准入配置" name="letInSetting">
                    <letInSettingView></letInSettingView>
                </el-tab-pane>
            </el-tabs>
        </div>
        <FixedButtons @scroll-to-top="_scrollToTop" />
    </div>
</template>

<script>
import axios from "axios";

import FixedButtons from "@/components/FixedButtons.vue";
import { scrollToTop } from "@/utils/utils";
import brandcheckView from "@/views/autoprice/setting/brandcheckView.vue";
import calfuncheckView from "@/views/autoprice/setting/calfuncheckView.vue";
import conditioncheckView from "@/views/autoprice/setting/conditioncheckView.vue";
import damagecheckView from "@/views/autoprice/setting/damagecheckView.vue";
import filterwordcheckView from "@/views/autoprice/setting/filterwordcheckView.vue";
import letInSettingView from "@/views/autoprice/setting/letInSettingView.vue";
import modelcheckView from "@/views/autoprice/setting/modelcheckView.vue";
import personalsettingView from "@/views/autoprice/setting/personalsettingView.vue";
import redpacketView from "@/views/autoprice/setting/redpacketView.vue";
import alphaNumView from "./components/alphaNumView.vue";

export default {
    components: {
        FixedButtons,
        redpacketView,
        brandcheckView,
        modelcheckView,
        damagecheckView,
        alphaNumView,
        conditioncheckView,
        filterwordcheckView,
        calfuncheckView,
        personalsettingView,
        letInSettingView,
    },
    data() {
        return {
            // 默认tab
            activeName: "letInSetting",

            //是否是需要的关键词
            keywordIsNeed: "1",
            props: { multiple: true, label: "paramValue", value: "看后端传来的" },

            //查询各平台
            platformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",

            // 查询各平台的品牌
            platformBrand: "/api/ProductBrandMapping/init",

            // 查询系统品牌
            sysBrand: "/api/ProductBrand/init",

            // 新增时候系统品牌查询
            addSysBrand: "/api/ProductBrand/queryDataByParam",

            // 分页查询其他平台品牌映射到系统品牌数据
            productBrandMapping: "/api/ProductBrandMapping/queryDataByParam",

            // 添加品牌映射关系
            addBrandMapping: "/api/ProductBrandMapping/insertBrandMapping",

            // 编辑品牌映射关系
            editBrandMapping: "/api/ProductBrandMapping/update",

            // 删除品牌映射关系
            deleteBrandMapping: "/api/ProductBrandMapping/deleteBrandMapping",

            //分页查询其他平台机型映射到系统机型数据
            correspondence: "/api/ProductModelMapping/queryModelMappingDataByParam",

            // 添加型号映射关系
            addMapping: "/api/ProductModelMapping/insertModelMapping",

            // 编辑型号映射关系
            editMapping: "/api/ProductModelMapping/update",

            // 删除型号映射关系
            deleteMapping: "/api/ProductModelMapping/deleteModelMapping",

            // 查询平台和机型映射初始化下拉框
            platformModelMapping: "/api/ProductModelMapping/init",

            // 查询系统标准的品牌和机型初始化下拉框
            syspStandardModel: "/api/ProductModel/init",

            // 系统标准型号
            sysModel: "/api/ProductModel/queryDataByParam",

            // 查询瑕疵数据
            flawData: "/api/PlatformDesc/queryDataByParam",

            // 查询瑕疵数据
            flawData: "/api/PlatformDesc/queryDataByParam",

            // 查询下拉框检索数据
            flawSearch: "/api/PlatformDesc/init",

            // 查询下拉框检索数据
            sysStandardFlaw: "/api/PjtDamageStandards/init",

            // 新增瑕疵映射
            addFlawMapping: "/api/PlatformDescReflect/insert",

            // 修改瑕疵映射
            editFlawMapping: "/api/PlatformDescReflect/update",

            // 删除瑕疵映射
            deleteFlawMapping: "/api/PlatformDescReflect/delete",

            // 当前页码
            currentPage: 1,
            // 默认每页显示条目数
            itemsPerPage: 10,
            itemsPerBrandPage: 10,
            itemsPerModelPage: 10,
            itemsPerFlawPage: 10,
            // 总页数
            allPagesBrand: 1,
            allPagesmodel: 1,
            allPagesFlaw: 1,

            BrandReflectShow: true,
            modelReflectShow: false,
            damageReflectShow: false,

            // 平台瑕疵项
            platformDesc: null,

            formConditionData: {
                // 其他平台型号
                otherBrandName: "",
                // 系统型号
                productBrandName: "",
                // 平台
                sources: "",
                // 是否映射
                status: "",
            },
            platformBrandList: [], //平台品牌
            sysBrandList: [], // 系统品牌
            addSysBrandList: [], // 添加时候的系统品牌
            //新增编辑弹框
            isBrandDialogVisible: false,
            // brandId: '', //新增id
            // productBrandId: '', //新增品牌id
            brandMappingmName: "",
            currentBrandMapping: {
                editId: undefined,
                id: "",
                productBrandId: "",
                brandName: "",
            },
            BrandMappingList: [], //其他平台映射系统平台列表

            formData: {
                brandId: "", //系统品牌id
                otherModelName: "", // 其他平台型号
                productModelName: "", // 系统型号
                sources: "", // 平台
                status: "", // 是否映射
            },
            statusList: [
                { key: "已映射", value: "0" },
                { key: "未映射", value: "1" },
            ],
            platformList: [], // 平台信息
            correspondenceList: [], // 对应信息
            sysPlatformBrandList: [], //系统平台品牌
            sysPlatformModelList: [], //系统平台型号
            otherPlatformModelList: [], // 其他平台型号
            sources: "", //平台
            brandId: "",
            isBrandId: "", //系统平台品牌是否映射过
            isBrandName: "",
            isDialogVisible: false, //新增编辑弹框
            sysModelList: [], // 系统标准型号列表
            otherPlatformName: "",
            currentMapping: {
                editId: undefined,
                id: "",
                brandId: "",
                productModelId: "",
                modelName: "",
                editProductModelId: "",
            },

            formFlawData: {
                descLevel1: "", //一级瑕疵
                descLevel2: "", // 二级瑕疵
                standardsKeyWord: "", // 系统瑕疵
                sources: "", // 平台
                status: "", // 是否映射
            },
            flawDataList: [], // 瑕疵映射列表
            flawOneLevelList: [], //一级瑕疵
            flawTwoLevelList: [], //二级瑕疵
            sysStandardFlawListOne: [], //系统一级瑕疵数据
            sysStandardFlawListTwo: [], //系统二级瑕疵数据
            sysStandardFlawListThree: [], //系统三级瑕疵数据
            isFlawDialogVisible: false, //瑕疵弹框
            currentFlawMapping: {
                editId: undefined,
                id: "",
                sdandardsLevel1: "", //一级名字
                sdandardsLevel2: "", //二级名字
                sdandardsLevel3: "", //三级名字
                otherPlatformDescId: "",
                pjtDescId: "",
            },
            otherPlatformNameFlaw: "",

            rules: {
                modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
            },
        };
    },
    created() {
        this.nickName = localStorage.getItem("nickname") || "";
        this.phone = localStorage.getItem("tel") || "";
    },
    methods: {
        // 页面顶部
        _scrollToTop() {
            scrollToTop(this.$refs.scrollableDiv);
        },

        // 标签页点击事件
        handleClick(tab, event) {
            if (tab.paneName == "second") {
                if (this.$refs.calfuncheckRef) {
                    this.$refs.calfuncheckRef.func1();
                }
            } else if (tab.paneName == "conditioncheck") {
                if (this.$refs.conditioncheckRef) {
                    this.$refs.conditioncheckRef.nowtabInit();
                }
            } else if (tab.paneName == "filterwordcheck") {
                if (this.$refs.filterwordcheckViewRef) {
                    this.$refs.filterwordcheckViewRef.nowtabInit();
                }
            } else if (tab.paneName == "modelcheck") {
                if (this.$refs.modelcheckRef) {
                    this.$refs.modelcheckRef.nowtabInit();
                }
            } else if (tab.paneName == "pjtdamagecheck") {
                if (this.$refs.pjtdamagecheckRef) {
                    this.$refs.pjtdamagecheckRef.nowtabInit();
                }
            } else if (tab.paneName == "alphaNumber") {
                if (this.$refs.alphaNumberRef) {
                    this.$refs.alphaNumberRef.nowtabInit();
                }
            }
        },
        searchManager() {
            this.getBrandMappingList();
        },

        // 查询平台
        getPlatformList() {
            axios
                .get(this.platformURL, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.platformList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 品牌映射逻辑开始
        //查询平台品牌
        getPlatformBrandList() {
            axios
                .get(this.platformBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.platformBrandList = res.data.data.otherPlatformNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        //查询系统品牌
        getSysBrandList() {
            axios
                .get(this.sysBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.sysBrandList = res.data.data.brandNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 获取成色判定种类
        getAddSysBrandList() {
            axios
                .get(this.addSysBrand, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                    },
                })
                .then((res) => {
                    this.addSysBrandList = res.data.data;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        selectBrandChange(value) {
            this.currentBrandMapping.productBrandId = value;
        },

        // 显示成色添加弹窗
        showBrandAddDialog(row) {
            this.isBrandDialogVisible = true;
            this.brandMappingmName = row.otherPlatformName;
            this.currentBrandMapping.editId = undefined;
            this.currentBrandMapping.id = row.id;
            this.currentBrandMapping.productBrandId = "";
            this.currentBrandMapping.brandName = "";
            this.getAddSysBrandList();
        },

        // 编辑品牌映射
        showBrandEditDialog(row) {
            this.platformDesc = row;
            this.isBrandDialogVisible = true;
            this.currentBrandMapping.editId = row.id;
            this.currentBrandMapping.id = row.id;
            this.currentBrandMapping.productBrandId = row.productBrandId;
            this.currentBrandMapping.brandName = row.productBrandName;
            // this.otherPlatformName = row.otherPlatformName;
            // this.currentMapping.productModelId = row.productModelName;
            // this.currentMapping.id = row.id;
            // this.currentMapping.editProductModelId = row.id;
            // this.currentMapping.modelName = row.modelName;
            this.getAddSysBrandList();
        },

        // 新增保存and编辑保存
        saveBrandMapping() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    if (this.currentBrandMapping.editId === undefined) {
                        const body = {
                            id: this.currentBrandMapping.id,
                            productBrandId: this.currentBrandMapping.productBrandId,
                        };
                        axios
                            .post(this.addBrandMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isBrandDialogVisible = false;
                                    this.getBrandMappingList();
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    } else {
                        const body = {
                            id: this.currentBrandMapping.id,
                            productBrandId: this.currentBrandMapping.productBrandId,
                        };
                        axios
                            .put(this.editBrandMapping, body, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.isBrandDialogVisible = false;
                                    this.getBrandMappingList();
                                    this.currentBrandMapping.productBrandId = "";
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: "error",
                                    });
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("新增失败", error);
                            });
                    }
                }
            });
        },

        // 删除品牌映射
        handleBrandMappingDelete(row) {
            try {
                this.$confirm("确认删除当前映射吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        axios
                            .delete(this.deleteBrandMapping + `?idList=${row.id}`, {
                                headers: {
                                    satoken: localStorage.sa,
                                    "Content-Type": "application/json",
                                },
                            })
                            .then((res) => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        message: res.data.message,
                                        type: "success",
                                    });
                                    this.getBrandMappingList();
                                } else {
                                    this.$message.error(res.data.data);
                                }
                            })
                            .catch((error) => {
                                // 处理错误
                                console.error("删除失败", error);
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            } catch (error) {
                console.error("Failed to delete user:", error);
            }
        },

        // 品牌映射关系列表
        getBrandMappingList() {
            axios
                .get(this.productBrandMapping, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerBrandPage,
                        ...this.formConditionData,
                    },
                })
                .then((res) => {
                    this.allPagesBrand = res.data.data.total;
                    this.BrandMappingList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 品牌映射逻辑结束

        // 型号映射逻辑开始
        // 查询
        searchModelManager() {
            this.getCorrespondenceList();
        },
        sourcesChange(val) {
            this.getPlatformModelMapping(val);
        },
        change(val) { },

        // 查询平台和机型映射初始化下拉框
        getPlatformModelMapping(val) {
            axios
                .get(this.platformModelMapping, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                        sources: val,
                    },
                })
                .then((res) => {
                    this.otherPlatformModelList = res.data.data.otherPlatformNameList;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 查询系统标准的品牌和机型初始化下拉框
        getSyspStandardModel(val) {
            axios
                .get(this.syspStandardModel, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                        brandId: val ? val : this.isBrandId,
                    },
                })
                .then((res) => {
                    if (val) {
                        this.sysPlatformModelList = res.data.data.modelNameList;
                    } else {
                        this.sysPlatformBrandList = res.data.data.brandIdAndNameList;
                        this.sysPlatformModelList = res.data.data.modelNameList;
                    }
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // 型号映射关系列表
        getCorrespondenceList() {
            axios
                .get(this.correspondence, {
                    headers: {
                        satoken: localStorage.sa,
                    },
                    params: {
                        ...this.formData,
                        pageNo: this.currentPage,
                        pageSize: this.itemsPerModelPage,
                    },
                })
                .then((res) => {
                    this.allPagesmodel = res.data.data.total;
                    this.correspondenceList = res.data.data.result;
                })
                .catch((error) => {
                    this.data = error;
                    console.error("获取数据出错:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {},
    computed: {},
    mounted() { },
};
</script>

<style lang="scss" scoped>
/* 表格样式*/
.el-table {
    justify-content: center;
    --el-table-header-bg-color: rgb(107, 107, 107);
    --el-table-text-color: #000000;
    --el-table-border: 1px solid #ebeef5;
}

.menu {
    padding-right: 12px;
}

.addone {
    width: 100%;
    justify-content: center;
    display: flex;
    background-color: aliceblue;
    border-radius: 0 0 20px 20px;
}

ul {
    padding: 0;

    li {
        list-style-type: none;
        margin-bottom: 15px;
    }
}

.practical-table {
    width: 100%;
    padding: 20px 40px;
    overflow: auto;
    //color: #ffffff;
}

.card {
    background-color: transparent;
    border: 1px solid transparent;
}

.form-control {
    background-color: #ded9d9;
    margin: 0;
}

.thead-dark {
    background-color: #585d6b;
    color: white;
}

// .form-group {
//     margin-bottom: 25px;
// }

:deep(.tiptop) {
    position: relative;
}

:deep(.tiptop .el-icon) {
    color: #ffffff;
    position: absolute;
    top: -53px;
    left: 215px;
}

:deep(.el-pagination > .is-first) {
    color: #ffffff;
}

:deep(.el-pagination__goto) {
    color: #ffffff;
}

:deep(.el-pagination__classifier) {
    color: #ffffff;
}

:deep(.el-pagination) {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

:deep(.el-form-item__content) {
    width: 160px;
}

.el-radio {
    color: #ffffff;
}

:deep(.el-tabs__item) {
    color: #ffffff;
}
</style>
